<script>
  import { onMount } from "svelte";
  import { result } from "../store.js";

  export let item = {
    type: "text",
    required: false,
    title: "",
    description: "",
    placeholder: "",
    options: [],
  };
  export let index = 0;

  onMount(() => {
    $result[index] = "";
  });
</script>

<select bind:value={$result[index]}>
  {#each item.options as option}
    <option value={option}>{option}</option>
  {/each}
</select>

<style>
  select {
    width: 100%;
  }
</style>
